{
  "a-chat": [
    "ui",
    "interface",
    "communication",
    "chat",
    "comment",
    "comments",
    "conversation",
    "dialog",
    "forum",
    "message",
    "messages",
    "speaking",
    "talk",
    "bubble",
    "bubbles"
  ],
  "account": [
    "user",
    "profile",
    "account",
    "avatar",
    "contact",
    "woman",
    "man",
    "person",
    "users",
    "member",
    "human",
    "friend",
    "follower"
  ],
  "activity": [
    "location",
    "start",
    "success",
    "winner",
    "flag",
    "banner",
    "finish",
    "message",
    "map",
    "tag",
    "important",
    "maps",
    "alert",
    "notify"
  ],
  "add-like": [
    "save",
    "ui",
    "interface",
    "award",
    "add",
    "plus",
    "bookmark",
    "favorite",
    "favourite",
    "love",
    "positive",
    "like",
    "vote",
    "star",
    "rate"
  ],
  "add-list": [
    "save",
    "new",
    "list",
    "collection",
    "add",
    "create",
    "watchlist"
  ],
  "ai": [
    "light",
    "edit",
    "filter",
    "photo",
    "brightness",
    "effect",
    "stars",
    "artificial",
    "intelligence",
    "spark",
    "sparkle",
    "chatgpt"
  ],
  "alarm-add": [
    "schedule",
    "new",
    "time",
    "add",
    "create",
    "plus",
    "addition",
    "alarm",
    "timer",
    "alert",
    "bell",
    "track",
    "event",
    "tracking"
  ],
  "algorithm": [
    "circuit",
    "preferences",
    "system",
    "settings",
    "nodes",
    "configuration",
    "cogwheel",
    "plugin",
    "components",
    "modules",
    "artificial",
    "intelligence",
    "api",
    "add-on",
    "extensions",
    "cryptocurrency",
    "sequence",
    "algorithm"
  ],
  "android": [
    "logo",
    "android",
    "google",
    "design",
    "development",
    "bot",
    "device",
    "mobile",
    "phone",
    "robot",
    "smartphone"
  ],
  "angry-44": [
    "emoticon",
    "angry",
    "furious",
    "smiley",
    "unhappy",
    "upset"
  ],
  "animation-31": [
    "play",
    "video",
    "key",
    "design",
    "development",
    "animation",
    "motion",
    "film",
    "frames",
    "movie",
    "steps"
  ],
  "apple": [
    "logo",
    "apple",
    "food",
    "fruit",
    "healthy",
    "nutrition",
    "natural",
    "design",
    "payment",
    "computer",
    "pay",
    "development",
    "device",
    "ipad",
    "iphone",
    "mac"
  ],
  "archery-target": [
    "arrow",
    "business",
    "sport",
    "goal",
    "goals",
    "target",
    "targeting",
    "game",
    "archery"
  ],
  "arrow-down": [
    "arrow",
    "bottom",
    "descend",
    "down",
    "downward"
  ],
  "arrow-left": [
    "arrow",
    "back",
    "left",
    "direction",
    "backward",
    "backwards",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "previous"
  ],
  "arrow-right": [
    "arrow",
    "forward",
    "right",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "next",
    "onward",
    "onwards"
  ],
  "arrow-sm-down": [
    "arrow",
    "bottom",
    "descend",
    "down",
    "downward"
  ],
  "arrow-sm-left": [
    "arrow",
    "back",
    "left",
    "direction",
    "backward",
    "backwards",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "previous"
  ],
  "arrow-sm-right": [
    "arrow",
    "forward",
    "right",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "next",
    "onward",
    "onwards"
  ],
  "arrow-up": [
    "arrow",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "top",
    "up",
    "upward",
    "upwards"
  ],
  "at-sign-2": [
    "inbox",
    "email",
    "contact",
    "address",
    "at sign"
  ],
  "attach": [
    "file",
    "ui",
    "interface",
    "inbox",
    "text",
    "email",
    "mail",
    "contact",
    "copy",
    "editing",
    "paper",
    "attachment",
    "attach",
    "attached",
    "attaching",
    "clip",
    "collate",
    "include",
    "paperclip"
  ],
  "attachment": [
    "file",
    "ui",
    "interface",
    "inbox",
    "text",
    "email",
    "mail",
    "contact",
    "copy",
    "editing",
    "paper",
    "attachment",
    "attach",
    "attached",
    "attaching",
    "clip",
    "collate",
    "include",
    "paperclip"
  ],
  "auto-focus": [
    "media",
    "photo",
    "camera",
    "option",
    "multimedia",
    "focus"
  ],
  "b-chart": [
    "data",
    "ui",
    "interface",
    "diagram",
    "stats",
    "growth",
    "chart",
    "graph",
    "statistics",
    "analytics",
    "bar",
    "stock",
    "bars",
    "level",
    "signal",
    "wifi"
  ],
  "b-eye": [
    "watch",
    "block",
    "view",
    "search",
    "visibility",
    "blind",
    "eye",
    "preview",
    "disabled",
    "hidden",
    "hide",
    "look",
    "observe",
    "overview",
    "see",
    "sight",
    "visible",
    "vision",
    "invisible"
  ],
  "bag": [
    "work",
    "business",
    "finance",
    "bag",
    "briefcase",
    "job",
    "office",
    "portfolio",
    "suitcase"
  ],
  "bag-time": [
    "time",
    "bag",
    "briefcase",
    "shopping",
    "discount",
    "ecommerce",
    "sale",
    "shop",
    "purse",
    "countdown",
    "buy",
    "cart",
    "handbag",
    "offer"
  ],
  "bag2": [
    "work",
    "business",
    "finance",
    "bag",
    "briefcase",
    "job",
    "office",
    "portfolio",
    "suitcase"
  ],
  "ball": [
    "play",
    "sport",
    "game",
    "ball",
    "football",
    "soccer",
    "fitness",
    "activity",
    "physical"
  ],
  "barcode": [
    "bar",
    "code",
    "barcode",
    "scan",
    "shopping",
    "price",
    "checkout",
    "label",
    "tag",
    "product",
    "scanner"
  ],
  "barcode-qr": [
    "shopping",
    "bar",
    "price",
    "checkout",
    "label",
    "code",
    "tag",
    "barcode",
    "product",
    "scan",
    "scanner",
    "qr",
    "qrcode"
  ],
  "bell": [
    "alert",
    "notification",
    "alarm",
    "reminder",
    "ring",
    "bell",
    "ui",
    "interface",
    "sound",
    "christmas",
    "buzz",
    "ringing",
    "ringtone",
    "wake"
  ],
  "bill": [
    "bill",
    "check",
    "cheque",
    "payment",
    "money",
    "receipt",
    "list",
    "price",
    "invoice",
    "prices",
    "billing"
  ],
  "bin": [
    "ui",
    "interface",
    "delete",
    "remove",
    "can",
    "waste",
    "garbage",
    "recycle",
    "recycling",
    "bin",
    "trash",
    "dump",
    "dustbin",
    "junk",
    "rubbish",
    "trashcan"
  ],
  "binoculars": [
    "zoom",
    "watch",
    "travel",
    "view",
    "nature",
    "explore",
    "binoculars",
    "outdoor",
    "observe",
    "vision",
    "adventure",
    "wildlife",
    "sightseeing",
    "discover",
    "object",
    "binocular"
  ],
  "biology": [
    "structure",
    "science",
    "molecule",
    "biology",
    "research",
    "virus",
    "dna",
    "helix",
    "organism",
    "chains",
    "genetics"
  ],
  "blockquote": [
    "line",
    "paragraph",
    "typography",
    "comment",
    "block",
    "quotation",
    "quote",
    "blockquote",
    "mark",
    "source",
    "speech",
    "author",
    "testimonial"
  ],
  "blog": [
    "media",
    "web",
    "news",
    "content",
    "marketing",
    "blogger",
    "wordpress",
    "article",
    "blog",
    "cms",
    "feed",
    "documentation",
    "copywriting"
  ],
  "bold": [
    "weight",
    "font",
    "text",
    "editing",
    "bold",
    "formatting"
  ],
  "book-39": [
    "education",
    "school",
    "book",
    "notebook"
  ],
  "book-open-2": [
    "education",
    "school",
    "agenda",
    "book",
    "contacts",
    "diary",
    "note",
    "notebook",
    "notes",
    "pad",
    "contact",
    "design",
    "read",
    "development",
    "learn",
    "reading",
    "study",
    "address",
    "code",
    "manual",
    "register"
  ],
  "bookmark": [
    "bookmark",
    "favorite",
    "favourite",
    "ribbon",
    "tag",
    "saved",
    "marker",
    "achievement",
    "award",
    "label",
    "reading",
    "study",
    "mark",
    "like",
    "bookmarking",
    "marked",
    "preference"
  ],
  "box-2": [
    "box",
    "delivery",
    "package",
    "shipping",
    "product",
    "post",
    "order",
    "shopping",
    "gift",
    "parcel",
    "present",
    "donation"
  ],
  "box-arrow-bottom-right": [
    "arrow",
    "forward",
    "right",
    "direction",
    "bottom",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "next",
    "onward",
    "onwards",
    "enlarge",
    "fullscreen",
    "zoom"
  ],
  "box-arrow-top-right": [
    "arrow",
    "forward",
    "right",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "next",
    "onward",
    "onwards",
    "top",
    "up",
    "upward",
    "upwards",
    "enlarge",
    "fullscreen",
    "zoom"
  ],
  "box-ctrl-down": [
    "arrow",
    "bottom",
    "descend",
    "down",
    "downward"
  ],
  "box-ctrl-left": [
    "arrow",
    "back",
    "left",
    "direction",
    "backward",
    "backwards",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "previous"
  ],
  "box-ctrl-up": [
    "arrow",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "top",
    "up",
    "upward",
    "upwards"
  ],
  "brain": [
    "healthcare",
    "health",
    "medical",
    "brain",
    "mind"
  ],
  "branch": [
    "arrow",
    "arrows",
    "change",
    "direction",
    "move",
    "navigation",
    "circle",
    "expand",
    "divide",
    "separate",
    "split",
    "branch",
    "controller",
    "git",
    "version"
  ],
  "briefcase-24": [
    "work",
    "business",
    "finance",
    "bag",
    "briefcase",
    "job",
    "office",
    "portfolio",
    "suitcase"
  ],
  "briefcase-25": [
    "work",
    "business",
    "finance",
    "bag",
    "briefcase",
    "job",
    "office",
    "portfolio",
    "suitcase"
  ],
  "briefcase-26": [
    "work",
    "business",
    "finance",
    "bag",
    "briefcase",
    "job",
    "office",
    "portfolio",
    "suitcase"
  ],
  "bulb": [
    "business",
    "finance",
    "bulb",
    "idea",
    "lamp",
    "light"
  ],
  "bullet-list": [
    "ui",
    "process",
    "organize",
    "schedule",
    "text",
    "list",
    "agenda",
    "design",
    "check",
    "development",
    "menu",
    "bullet",
    "bullets",
    "checklist",
    "item",
    "items",
    "listing",
    "tasks",
    "todo"
  ],
  "bullet-list-68": [
    "ui",
    "process",
    "organize",
    "schedule",
    "text",
    "list",
    "agenda",
    "design",
    "check",
    "development",
    "menu",
    "bullet",
    "bullets",
    "checklist",
    "item",
    "items",
    "listing",
    "tasks",
    "todo"
  ],
  "bullet-list-70": [
    "ui",
    "process",
    "organize",
    "schedule",
    "text",
    "list",
    "agenda",
    "design",
    "check",
    "development",
    "menu",
    "bullet",
    "bullets",
    "checklist",
    "item",
    "items",
    "listing",
    "tasks",
    "todo"
  ],
  "butterfly": [
    "animal",
    "nature",
    "bug",
    "insect",
    "fly",
    "butterfly",
    "wings",
    "spring",
    "garden",
    "freedom"
  ],
  "button-play": [
    "play",
    "ui",
    "media",
    "control",
    "button",
    "multimedia"
  ],
  "button-power": [
    "ui",
    "media",
    "power",
    "button",
    "multimedia",
    "off",
    "on"
  ],
  "c-add": [
    "ui",
    "interface",
    "expand",
    "increase",
    "new",
    "add",
    "create",
    "plus",
    "addition",
    "positive"
  ],
  "c-check": [
    "ui",
    "interface",
    "success",
    "select",
    "check",
    "selected",
    "mark",
    "accept",
    "approve",
    "approved",
    "checkmark",
    "complete",
    "completed",
    "done",
    "checked",
    "tick",
    "checkbox",
    "ok"
  ],
  "c-delete": [
    "ui",
    "interface",
    "close",
    "exit",
    "decrease",
    "delete",
    "remove",
    "minus",
    "cancel",
    "deletion",
    "less",
    "removal",
    "subtract"
  ],
  "c-info": [
    "ui",
    "interface",
    "sign",
    "info",
    "travel",
    "alert",
    "information",
    "notification",
    "about",
    "faq",
    "help",
    "support",
    "tooltip"
  ],
  "c-question": [
    "ui",
    "interface",
    "sign",
    "info",
    "mark",
    "alert",
    "information",
    "notification",
    "about",
    "faq",
    "help",
    "support",
    "ask",
    "query",
    "question"
  ],
  "c-remove": [
    "ui",
    "interface",
    "close",
    "exit",
    "cross",
    "delete",
    "remove",
    "cancel",
    "deletion",
    "removal",
    "denied",
    "discard",
    "dismiss",
    "wrong"
  ],
  "c-warning": [
    "ui",
    "interface",
    "sign",
    "info",
    "stop",
    "mark",
    "error",
    "danger",
    "alert",
    "attention",
    "caution",
    "exclamation",
    "information",
    "notification",
    "warning"
  ],
  "cake": [
    "food",
    "anniversary",
    "birthday",
    "cake",
    "candles",
    "celebration",
    "dessert",
    "party",
    "sweet",
    "bakery",
    "eat",
    "pie",
    "holidays",
    "emoticon",
    "smiley",
    "candle"
  ],
  "calculator": [
    "accounting",
    "budget",
    "calculator",
    "math",
    "operations",
    "business",
    "finance",
    "education",
    "school",
    "calculate",
    "mathematics"
  ],
  "calendar": [
    "plan",
    "time",
    "schedule",
    "date",
    "reminder",
    "event",
    "appointment",
    "calendar",
    "ui",
    "interface",
    "day",
    "planning",
    "month",
    "timetable",
    "year"
  ],
  "calendar-2": [
    "day",
    "schedule",
    "time",
    "calendar",
    "appointment",
    "event",
    "plan",
    "planning",
    "date",
    "month",
    "timetable",
    "year"
  ],
  "car": [
    "drive",
    "car",
    "vehicle",
    "auto",
    "transportation",
    "automobile"
  ],
  "cards": [
    "layer",
    "layers",
    "design",
    "card",
    "style",
    "palette",
    "cards"
  ],
  "caret-sm-up": [
    "arrow",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "top",
    "up",
    "upward",
    "upwards"
  ],
  "cash-register": [
    "shopping",
    "cash",
    "payment",
    "money",
    "shop",
    "checkout",
    "register",
    "buy",
    "store",
    "till"
  ],
  "casino": [
    "play",
    "building",
    "poker",
    "casino",
    "gambling",
    "jackpot",
    "las vegas"
  ],
  "centralize": [
    "arrow",
    "circle",
    "round",
    "center",
    "align",
    "alignment",
    "arrange",
    "central",
    "centralize",
    "centralized",
    "conference",
    "display",
    "layout",
    "meeting",
    "preferences",
    "structure",
    "tool"
  ],
  "change": [
    "arrow",
    "line",
    "alternative",
    "arrows",
    "change",
    "direction",
    "exchange",
    "files",
    "flip",
    "horizontal",
    "swap",
    "switch",
    "transmit",
    "navigation",
    "directions",
    "gps",
    "location",
    "payments"
  ],
  "change-direction": [
    "arrow",
    "line",
    "alternative",
    "arrows",
    "change",
    "direction",
    "exchange",
    "files",
    "flip",
    "horizontal",
    "swap",
    "switch",
    "transmit"
  ],
  "chart-bar-32": [
    "data",
    "diagram",
    "business",
    "finance",
    "chart",
    "graph",
    "report",
    "statistics",
    "analytics",
    "bar"
  ],
  "chat-bot": [
    "chat",
    "conversation",
    "message",
    "bot",
    "robot",
    "support",
    "bubble",
    "chatting",
    "assistant",
    "chatbot"
  ],
  "check": [
    "mark",
    "tick",
    "success",
    "complete",
    "checked",
    "check",
    "approved",
    "done",
    "select",
    "selected",
    "accept",
    "approve",
    "checkmark",
    "completed",
    "checkbox",
    "ok"
  ],
  "check-double": [
    "double",
    "success",
    "check",
    "read",
    "selected",
    "mark",
    "approved",
    "checkmark",
    "completed",
    "done",
    "checked",
    "tick",
    "delivered",
    "complete"
  ],
  "checkbox-btn": [
    "control",
    "button",
    "selection",
    "mark",
    "choice",
    "checked",
    "question",
    "checkbox",
    "questionnaire",
    "forms",
    "tickbox",
    "yes"
  ],
  "checkbox-btn-checked": [
    "control",
    "button",
    "selection",
    "mark",
    "choice",
    "checked",
    "question",
    "checkbox",
    "questionnaire",
    "forms",
    "tickbox",
    "yes"
  ],
  "checkbox-list": [
    "lines",
    "select",
    "text",
    "list",
    "check",
    "options",
    "todo",
    "complete",
    "checked",
    "tick",
    "checkbox",
    "answer",
    "filter",
    "completed",
    "question",
    "questionnaire",
    "survey"
  ],
  "chevron-down": [
    "arrow",
    "bottom",
    "descend",
    "down",
    "downward"
  ],
  "chevron-top": [
    "arrow",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "top",
    "up",
    "upward",
    "upwards"
  ],
  "clock": [
    "clock",
    "time",
    "watch",
    "alarm",
    "timer",
    "progress",
    "availability",
    "available",
    "daily",
    "day",
    "monthly",
    "schedule",
    "weekly",
    "yearly",
    "wait",
    "alert",
    "appointment",
    "countdown",
    "track",
    "event",
    "tracking",
    "deadline",
    "hour",
    "history"
  ],
  "cloud": [
    "storage",
    "server",
    "cloud",
    "network",
    "weather",
    "backup",
    "ui",
    "interface",
    "cloudy",
    "forecast",
    "icloud"
  ],
  "cloud-mining": [
    "cloud",
    "network",
    "money",
    "bitcoin",
    "digital",
    "cryptocurrency",
    "mining"
  ],
  "cloud-upload": [
    "arrow",
    "top",
    "cloud",
    "share",
    "storage",
    "transfer",
    "server",
    "upload",
    "export",
    "send",
    "internet",
    "direction",
    "up",
    "data",
    "file",
    "input",
    "save",
    "sync",
    "weather",
    "backup",
    "ftp",
    "hosting",
    "import"
  ],
  "cog-wheel": [
    "control",
    "preferences",
    "tool",
    "system",
    "edit",
    "options",
    "settings",
    "filter",
    "adjust",
    "adjustment",
    "option",
    "wheel",
    "configuration",
    "configure",
    "gear",
    "parameter",
    "parameters",
    "setting",
    "setup",
    "tools",
    "engine",
    "cogwheel"
  ],
  "collection": [
    "file",
    "education",
    "school",
    "book",
    "notebook",
    "library",
    "design",
    "read",
    "development",
    "collection",
    "gallery",
    "album",
    "binder",
    "catalog",
    "catalogue",
    "knowledge",
    "label",
    "learn",
    "learning",
    "magazine",
    "press",
    "reading",
    "study"
  ],
  "column": [
    "left",
    "right",
    "interface",
    "browser",
    "layout",
    "page",
    "website",
    "boxes",
    "grid",
    "mockup",
    "site",
    "table",
    "tile",
    "wireframe",
    "sidebar",
    "webpage"
  ],
  "comment": [
    "ui",
    "interface",
    "communication",
    "answer",
    "chat",
    "comment",
    "comments",
    "conversation",
    "dialog",
    "forum",
    "message",
    "messages",
    "reply",
    "speaking",
    "talk",
    "bubble",
    "bubbles"
  ],
  "comments": [
    "communication",
    "chat",
    "comments",
    "conversation",
    "dialog",
    "forum",
    "messages",
    "speaking",
    "talk",
    "bubbles"
  ],
  "components": [
    "ui",
    "system",
    "design",
    "template",
    "components",
    "patterns",
    "guidelines",
    "component",
    "module"
  ],
  "condition": [
    "git",
    "fork",
    "programming",
    "push",
    "commit",
    "pull",
    "svn"
  ],
  "contacts": [
    "user",
    "book",
    "contacts",
    "person",
    "address",
    "phonebook",
    "business",
    "list",
    "finance",
    "agenda",
    "diary",
    "note",
    "notebook",
    "notes",
    "pad",
    "contact",
    "man",
    "call",
    "users",
    "human"
  ],
  "copy": [
    "layers",
    "stack",
    "page",
    "copy",
    "clone",
    "duplicate",
    "content",
    "files",
    "file",
    "backup",
    "group",
    "document",
    "copies",
    "documents",
    "paste",
    "draft"
  ],
  "copy-2": [
    "layers",
    "stack",
    "page",
    "copy",
    "clone",
    "duplicate",
    "content",
    "files",
    "file",
    "backup",
    "group",
    "document",
    "copies",
    "documents",
    "paste",
    "draft"
  ],
  "crane": [
    "work",
    "building",
    "construction",
    "vehicle",
    "lift",
    "build",
    "crane",
    "under construction",
    "construction site",
    "work in progress"
  ],
  "cross": [
    "ui",
    "interface",
    "close",
    "exit",
    "cross",
    "delete",
    "remove",
    "cancel",
    "deletion",
    "removal",
    "denied",
    "discard",
    "dismiss",
    "wrong"
  ],
  "cross-small": [
    "ui",
    "interface",
    "close",
    "exit",
    "cross",
    "delete",
    "remove",
    "cancel",
    "deletion",
    "removal",
    "denied",
    "discard",
    "dismiss",
    "wrong"
  ],
  "crossroad": [
    "direction",
    "directions",
    "navigation",
    "route",
    "road",
    "path",
    "way",
    "street",
    "signpost",
    "sign",
    "crossroad",
    "crossroads",
    "intersection",
    "junction",
    "fork",
    "map",
    "maps",
    "location",
    "branch",
    "decision",
    "choice",
    "split",
    "turn"
  ],
  "cut": [
    "shopping",
    "deal",
    "discount",
    "ecommerce",
    "sale",
    "shop",
    "cut",
    "coupon",
    "reduction",
    "offer"
  ],
  "cyborg": [
    "robot",
    "head",
    "ai",
    "cyborg",
    "droid",
    "artificial",
    "intelligence",
    "machine",
    "avatar",
    "android",
    "clone",
    "knowledge",
    "robotic"
  ],
  "d-edit": [
    "ui",
    "interface",
    "text",
    "message",
    "note",
    "pen",
    "edit",
    "pencil",
    "write",
    "draw",
    "create",
    "editing",
    "compose",
    "editor",
    "draft"
  ],
  "data-upload": [
    "arrow",
    "direction",
    "top",
    "up",
    "upward",
    "cloud",
    "data",
    "file",
    "input",
    "save",
    "share",
    "storage",
    "transfer",
    "backup",
    "ftp",
    "hosting",
    "import",
    "server",
    "upload",
    "ui",
    "interface"
  ],
  "database": [
    "cloud",
    "data",
    "storage",
    "hosting",
    "server",
    "ui",
    "interface",
    "web",
    "hardware",
    "memory",
    "database",
    "harddriver",
    "cms"
  ],
  "delete-forever": [
    "delete",
    "waste",
    "garbage",
    "bin",
    "trash",
    "dump",
    "rubbish",
    "trashcan"
  ],
  "delivery-3": [
    "box",
    "shopping",
    "delivery",
    "pack",
    "package",
    "shipping",
    "service",
    "transport",
    "cargo",
    "courier",
    "logistics",
    "ship"
  ],
  "device-mobile": [
    "communication",
    "conversation",
    "talk",
    "contact",
    "android",
    "development",
    "device",
    "mobile",
    "phone",
    "smartphone",
    "iphone",
    "ios",
    "telephone",
    "call",
    "cellular",
    "smart",
    "ringing",
    "landline",
    "calling"
  ],
  "diamond": [
    "diamond",
    "ruby",
    "stone",
    "sparkle",
    "jewel",
    "luxury",
    "gem",
    "precious",
    "shiny",
    "crystal",
    "emerald",
    "clothes",
    "accessory",
    "jewelry",
    "object"
  ],
  "diamonds-suits": [
    "suit",
    "game",
    "cards",
    "tiles",
    "playing",
    "deck",
    "poker",
    "casino",
    "gambling",
    "diamonds",
    "blackjack"
  ],
  "digital-key": [
    "password",
    "security",
    "key",
    "computer",
    "vault",
    "bitcoin",
    "coding",
    "science",
    "privacy",
    "protection",
    "access",
    "digital",
    "artificial",
    "intelligence",
    "cryptocurrency",
    "cryptography",
    "cryptology",
    "protecion"
  ],
  "directions": [
    "direction",
    "navigation",
    "location",
    "path",
    "available",
    "open",
    "track",
    "route",
    "street",
    "accessible",
    "walkable"
  ],
  "disk": [
    "download",
    "save",
    "storage",
    "backup",
    "ui",
    "interface",
    "tech",
    "technology",
    "album",
    "drive",
    "disk",
    "cd",
    "dvd",
    "blueray",
    "compact",
    "disc",
    "electronics",
    "entertainment",
    "diskette",
    "floppy",
    "floppydisk"
  ],
  "divider": [
    "line",
    "horizontal",
    "divide",
    "split",
    "splitter",
    "divider",
    "layout",
    "design",
    "development",
    "blocks",
    "horizontally",
    "separation"
  ],
  "document": [
    "file",
    "folder",
    "document",
    "text",
    "note",
    "report",
    "page",
    "paper",
    "item",
    "draft",
    "single",
    "letter",
    "content",
    "sheet"
  ],
  "document-copy": [
    "files",
    "file",
    "folder",
    "group",
    "document",
    "text",
    "note",
    "report",
    "page",
    "copy",
    "paper",
    "documents",
    "duplicate",
    "item",
    "draft",
    "single",
    "letter",
    "content",
    "sheet"
  ],
  "documentation": [
    "education",
    "school",
    "book",
    "notebook"
  ],
  "dog": [
    "animal",
    "pet",
    "dog",
    "puppy",
    "nature",
    "head",
    "face"
  ],
  "done": [
    "mark",
    "tick",
    "success",
    "complete",
    "checked",
    "check",
    "approved",
    "done",
    "select",
    "selected",
    "accept",
    "approve",
    "checkmark",
    "completed",
    "checkbox",
    "ok"
  ],
  "dots": [
    "horizontal",
    "navigation",
    "menu",
    "settings",
    "dots",
    "more",
    "loading",
    "progress",
    "wait",
    "spinner",
    "loader"
  ],
  "double-arrow-left": [
    "arrow",
    "back",
    "left",
    "arrows",
    "direction",
    "backward",
    "backwards",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "previous",
    "double",
    "rewind"
  ],
  "double-arrow-right": [
    "arrow",
    "forward",
    "right",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "next",
    "onward",
    "onwards",
    "double"
  ],
  "double-check": [
    "double",
    "success",
    "check",
    "read",
    "selected",
    "mark",
    "approved",
    "checkmark",
    "completed",
    "done",
    "checked",
    "tick",
    "delivered",
    "complete"
  ],
  "download": [
    "arrow",
    "bottom",
    "descend",
    "down",
    "downward",
    "data",
    "download",
    "file",
    "input",
    "save",
    "storage",
    "backup",
    "import",
    "receive"
  ],
  "drag": [
    "arrow",
    "move",
    "upload",
    "resize",
    "drag",
    "drop",
    "cursor",
    "select",
    "design",
    "development",
    "click",
    "mouse",
    "point",
    "pointer",
    "paste",
    "reposition",
    "touch"
  ],
  "drink": [
    "glass",
    "bottle",
    "water",
    "drink",
    "beverage",
    "juice",
    "soft",
    "coke",
    "soda",
    "softdrink"
  ],
  "drop": [
    "weather",
    "ui",
    "interface",
    "energy",
    "environment",
    "drop",
    "animal",
    "nature",
    "healthcare",
    "health",
    "medical",
    "ink",
    "tear",
    "water",
    "rain",
    "blood",
    "drip",
    "dripping",
    "droplet",
    "humid",
    "liquid",
    "oil",
    "petroleum",
    "wet"
  ],
  "e-add": [
    "ui",
    "interface",
    "expand",
    "increase",
    "new",
    "add",
    "create",
    "plus",
    "addition",
    "positive"
  ],
  "e-delete": [
    "ui",
    "interface",
    "close",
    "exit",
    "decrease",
    "delete",
    "remove",
    "minus",
    "cancel",
    "deletion",
    "less",
    "removal",
    "subtract"
  ],
  "e-remove": [
    "ui",
    "interface",
    "close",
    "exit",
    "cross",
    "delete",
    "remove",
    "cancel",
    "deletion",
    "removal",
    "denied",
    "discard",
    "dismiss",
    "wrong"
  ],
  "edit": [
    "ui",
    "interface",
    "text",
    "message",
    "note",
    "pen",
    "edit",
    "pencil",
    "write",
    "draw",
    "create",
    "editing",
    "compose",
    "editor",
    "draft",
    "rename"
  ],
  "eight": [
    "number",
    "eight"
  ],
  "email": [
    "ui",
    "interface",
    "communication",
    "post",
    "send",
    "email",
    "mail",
    "message",
    "messages",
    "contact",
    "write",
    "envelope",
    "letter",
    "mailbox",
    "news",
    "newsletter"
  ],
  "empty": [
    "circle",
    "no",
    "search",
    "results",
    "empty",
    "slash",
    "zero",
    "no results",
    "blank",
    "nothing"
  ],
  "engine-start": [
    "switch",
    "start",
    "power",
    "on",
    "engine",
    "run"
  ],
  "enlarge": [
    "arrow",
    "arrows",
    "direction",
    "down",
    "up",
    "enlarge",
    "expand",
    "increase",
    "maximize",
    "vertical",
    "select"
  ],
  "expand": [
    "expand",
    "fullscreen",
    "maximize",
    "full",
    "resize",
    "screen",
    "arrow",
    "move",
    "out",
    "enlarge",
    "increase",
    "reach",
    "window",
    "zoom",
    "center"
  ],
  "export": [
    "arrow",
    "top",
    "share",
    "transfer",
    "upload",
    "export",
    "send",
    "up",
    "file",
    "storage",
    "connection",
    "social",
    "network",
    "outbox",
    "output",
    "sharing"
  ],
  "eye": [
    "open",
    "watch",
    "view",
    "visibility",
    "eye",
    "preview",
    "show",
    "look",
    "visible",
    "vision",
    "audience",
    "ui",
    "interface",
    "search",
    "observe",
    "overview",
    "see",
    "sight"
  ],
  "f-add": [
    "ui",
    "interface",
    "expand",
    "increase",
    "new",
    "add",
    "create",
    "plus",
    "addition",
    "positive"
  ],
  "f-dashboard": [
    "ui",
    "interface",
    "scale",
    "growth",
    "settings",
    "meter",
    "dashboard",
    "speed",
    "widget",
    "setting",
    "fast",
    "gauge",
    "indicator",
    "metrics",
    "odometer",
    "performance",
    "productivity",
    "speedometer"
  ],
  "f-remove": [
    "ui",
    "interface",
    "close",
    "exit",
    "cross",
    "delete",
    "remove",
    "cancel",
    "deletion",
    "removal",
    "denied",
    "discard",
    "dismiss",
    "wrong"
  ],
  "face-recognition": [
    "password",
    "security",
    "machine",
    "identity",
    "technology",
    "facial",
    "portrait",
    "photo",
    "learning",
    "camera",
    "focus",
    "scanner",
    "face",
    "selfie",
    "recognition",
    "artificial",
    "intelligence",
    "face id"
  ],
  "favorite": [
    "day",
    "award",
    "favorite",
    "favourite",
    "love",
    "romantic",
    "like",
    "heart",
    "valentine",
    "wishlist",
    "dating",
    "relationship",
    "romance"
  ],
  "feedback": [
    "chat",
    "comment",
    "message",
    "talk",
    "customer",
    "bubble",
    "rating",
    "review",
    "feedback",
    "opinion"
  ],
  "file": [
    "page",
    "data",
    "document",
    "paper",
    "file",
    "folder",
    "text",
    "note",
    "report",
    "item",
    "draft",
    "single",
    "letter",
    "content",
    "sheet",
    "folded"
  ],
  "file-article": [
    "file",
    "post",
    "folder",
    "document",
    "paragraph",
    "text",
    "note",
    "report",
    "page",
    "paper",
    "item",
    "draft",
    "single",
    "letter",
    "content",
    "sheet",
    "folded",
    "article",
    "blog"
  ],
  "file-audio": [
    "play",
    "file",
    "media",
    "music",
    "player",
    "document",
    "format",
    "note",
    "multimedia",
    "audio",
    "mp3",
    "sound",
    "soundtrack",
    "radio",
    "song",
    "listen"
  ],
  "file-chart-bar": [
    "data",
    "file",
    "diagram",
    "lines",
    "document",
    "chart",
    "graph",
    "report",
    "statistics",
    "page",
    "bars",
    "paper",
    "files",
    "stats",
    "growth",
    "folder",
    "format",
    "office",
    "analytics",
    "bar",
    "stock",
    "documents",
    "catalog",
    "envelope",
    "level",
    "archive"
  ],
  "file-chart-pie": [
    "data",
    "file",
    "diagram",
    "document",
    "chart",
    "graph",
    "pie",
    "report",
    "statistics",
    "page",
    "paper",
    "files",
    "stats",
    "folder",
    "format",
    "piechart",
    "office",
    "analytics",
    "percent",
    "documents",
    "catalog",
    "envelope",
    "archive",
    "charting",
    "charts",
    "results"
  ],
  "file-copies": [
    "files",
    "file",
    "folder",
    "group",
    "document",
    "text",
    "note",
    "report",
    "page",
    "copy",
    "paper",
    "copies",
    "documents",
    "duplicate",
    "item",
    "draft",
    "single",
    "letter",
    "content",
    "sheet"
  ],
  "file-csv": [
    "file",
    "extension",
    "format",
    "microsoft",
    "csv",
    "excel",
    "folder"
  ],
  "file-dev": [
    "file",
    "folder",
    "tool",
    "document",
    "development",
    "programming",
    "paper",
    "code",
    "coding",
    "develop",
    "script",
    "tag",
    "source"
  ],
  "file-docx": [
    "file",
    "document",
    "extension",
    "format",
    "microsoft",
    "word",
    "docx",
    "folder"
  ],
  "file-download": [
    "arrow",
    "down",
    "data",
    "download",
    "file",
    "import",
    "document",
    "page",
    "paper",
    "bottom",
    "descend",
    "downward",
    "input",
    "save",
    "share",
    "storage",
    "transfer",
    "inbox",
    "folder",
    "archive"
  ],
  "file-export": [
    "arrow",
    "direction",
    "top",
    "up",
    "cloud",
    "data",
    "file",
    "input",
    "save",
    "share",
    "storage",
    "sync",
    "transfer",
    "backup",
    "ftp",
    "hosting",
    "import",
    "server",
    "upload",
    "folder",
    "document",
    "paper",
    "item"
  ],
  "file-folder": [
    "files",
    "file",
    "folder",
    "document",
    "format",
    "office",
    "paper",
    "documents",
    "catalog",
    "envelope",
    "archive"
  ],
  "file-history": [
    "availability",
    "available",
    "clock",
    "daily",
    "day",
    "every",
    "monthly",
    "schedule",
    "weekly",
    "yearly",
    "document",
    "time",
    "watch",
    "wait",
    "paper",
    "alarm",
    "timer",
    "alert",
    "appointment",
    "countdown",
    "track",
    "event",
    "tracking",
    "deadline",
    "hour",
    "history"
  ],
  "file-ics": [
    "files",
    "file",
    "extension",
    "format",
    "calendar",
    "ics",
    "folder"
  ],
  "file-image": [
    "image",
    "picture",
    "photo",
    "img",
    "media",
    "format",
    "canvas",
    "gallery",
    "photography",
    "graphic",
    "landscape",
    "album",
    "multimedia"
  ],
  "file-json": [
    "data",
    "file",
    "document",
    "extension",
    "json"
  ],
  "file-md": [
    "file",
    "extension",
    "format",
    "markdown",
    "folder",
    "design",
    "development"
  ],
  "file-new": [
    "file",
    "folder",
    "document",
    "new",
    "add",
    "create",
    "plus",
    "paper",
    "item"
  ],
  "file-pdf": [
    "file",
    "document",
    "extension",
    "format",
    "vector",
    "portable",
    "adobe",
    "pdf",
    "folder",
    "design",
    "development"
  ],
  "file-pptx": [
    "file",
    "extension",
    "format",
    "powerpoint",
    "pptx",
    "folder"
  ],
  "file-question": [
    "data",
    "file",
    "document",
    "page",
    "paper",
    "mark",
    "faq",
    "help",
    "support",
    "question",
    "sign",
    "info",
    "folder",
    "item",
    "alert",
    "information",
    "notification",
    "ask",
    "query",
    "unknown"
  ],
  "file-text": [
    "file",
    "post",
    "folder",
    "document",
    "text",
    "note",
    "report",
    "page",
    "paper",
    "item",
    "draft",
    "single",
    "letter",
    "content",
    "sheet",
    "folded",
    "article",
    "blog"
  ],
  "file-upload": [
    "arrow",
    "top",
    "data",
    "file",
    "share",
    "transfer",
    "upload",
    "export",
    "document",
    "send",
    "page",
    "paper",
    "direction",
    "up",
    "upward",
    "cloud",
    "input",
    "save",
    "storage",
    "backup",
    "ftp",
    "hosting",
    "import",
    "server",
    "inbox",
    "folder"
  ],
  "file-user": [
    "data",
    "file",
    "share",
    "user",
    "document",
    "profile",
    "account",
    "person",
    "page",
    "paper",
    "communication",
    "post",
    "folder",
    "item",
    "users",
    "member"
  ],
  "file-vector": [
    "file",
    "document",
    "pen",
    "edit",
    "pencil",
    "write",
    "editing",
    "draft",
    "nib",
    "vector"
  ],
  "file-video": [
    "play",
    "media",
    "video",
    "film",
    "movie",
    "multimedia"
  ],
  "file-xlsx": [
    "file",
    "extension",
    "format",
    "excel",
    "xlsx",
    "folder"
  ],
  "file-zip": [
    "file",
    "folder",
    "document",
    "extension",
    "archive",
    "zip",
    "compressed",
    "zipped"
  ],
  "filter": [
    "settings",
    "filter",
    "funnel",
    "filtering",
    "ui",
    "interface",
    "tool",
    "categories",
    "category",
    "filters",
    "refine",
    "search",
    "sort",
    "seo"
  ],
  "filter-check": [
    "navigation",
    "ui",
    "interface",
    "success",
    "check",
    "settings",
    "filter",
    "filters",
    "sort",
    "mark",
    "tick",
    "configuration",
    "ok",
    "nav"
  ],
  "fire": [
    "fire",
    "travel",
    "animal",
    "nature",
    "flame",
    "fireplace",
    "wood"
  ],
  "firewall": [
    "interface",
    "security",
    "network",
    "app",
    "safe",
    "grid",
    "protection",
    "antivirus",
    "encryption",
    "firewall",
    "shield",
    "tiles",
    "defense",
    "lock",
    "tech",
    "technology",
    "secure"
  ],
  "five": [
    "five",
    "number"
  ],
  "flag-points-32": [
    "location",
    "message",
    "map",
    "tag",
    "important",
    "maps",
    "alert",
    "flag",
    "banner",
    "notify"
  ],
  "flash": [
    "weather",
    "energy",
    "media",
    "light",
    "photo",
    "multimedia",
    "flash",
    "lightning",
    "activity",
    "cardio",
    "calories"
  ],
  "flashlight": [
    "light",
    "portable",
    "emergency",
    "battery",
    "camping",
    "flashlight",
    "beam",
    "torch",
    "handheld",
    "illumination",
    "spotlight"
  ],
  "floppy-disk": [
    "download",
    "save",
    "storage",
    "backup",
    "size",
    "drive",
    "disk",
    "diskette",
    "floppy",
    "floppydisk",
    "device",
    "memory"
  ],
  "folder": [
    "storage",
    "data",
    "office",
    "documents",
    "files",
    "folder",
    "archive",
    "directory",
    "file",
    "document",
    "format",
    "paper",
    "catalog",
    "envelope"
  ],
  "folder-add": [
    "files",
    "file",
    "folder",
    "document",
    "format",
    "new",
    "office",
    "add",
    "create",
    "plus",
    "paper",
    "documents",
    "catalog",
    "item",
    "envelope",
    "archive"
  ],
  "folder-user": [
    "files",
    "file",
    "share",
    "user",
    "communication",
    "post",
    "folder",
    "document",
    "format",
    "profile",
    "office",
    "account",
    "person",
    "paper",
    "documents",
    "catalog",
    "envelope",
    "archive",
    "users",
    "member",
    "data",
    "storage",
    "directory"
  ],
  "four": [
    "four",
    "number"
  ],
  "gallery-view": [
    "line",
    "ui",
    "interface",
    "layout",
    "list",
    "shape",
    "gallery",
    "boxes",
    "column",
    "grid",
    "row",
    "table",
    "tile",
    "view",
    "square",
    "squares"
  ],
  "gift": [
    "box",
    "package",
    "gift",
    "present",
    "exchange",
    "shopping",
    "holidays",
    "surprise",
    "birthday",
    "christmas",
    "donation",
    "wrapped"
  ],
  "globe-2": [
    "globe",
    "world",
    "map"
  ],
  "goal": [
    "arrow",
    "business",
    "finance",
    "dartboard",
    "darts",
    "goal",
    "goals",
    "target",
    "targeting"
  ],
  "goal-65": [
    "arrow",
    "business",
    "finance",
    "dartboard",
    "darts",
    "goal",
    "goals",
    "target",
    "targeting"
  ],
  "group": [
    "files",
    "file",
    "group",
    "document",
    "layer",
    "layers",
    "note",
    "design",
    "report",
    "development",
    "copy",
    "paper",
    "clone",
    "copies",
    "documents",
    "duplicate",
    "paste"
  ],
  "hand-card": [
    "finance",
    "shopping",
    "payment",
    "money",
    "hand",
    "shop",
    "card",
    "charge",
    "checkout",
    "credit",
    "debit",
    "method",
    "methods",
    "swipe",
    "buy",
    "credit card",
    "transaction"
  ],
  "happy-sun": [
    "emoticon",
    "smiley",
    "cheerful",
    "happy",
    "smile",
    "summer",
    "sun"
  ],
  "hash": [
    "sign",
    "pound",
    "mark",
    "link",
    "trending",
    "number",
    "hash",
    "hashtag",
    "href"
  ],
  "heart": [
    "favorite",
    "favourite",
    "like",
    "love",
    "heart",
    "day",
    "award",
    "healthcare",
    "health",
    "medical",
    "romantic",
    "valentine",
    "wishlist",
    "dating",
    "relationship",
    "romance"
  ],
  "help": [
    "ui",
    "interface",
    "sign",
    "info",
    "mark",
    "alert",
    "information",
    "notification",
    "about",
    "faq",
    "help",
    "support",
    "ask",
    "query",
    "question"
  ],
  "hierarchy": [
    "network",
    "work",
    "structure",
    "business",
    "hierarchy",
    "finance",
    "chart",
    "map",
    "relations",
    "sitemap",
    "flow"
  ],
  "home-3": [
    "office",
    "building",
    "estate",
    "home",
    "house",
    "real",
    "page",
    "address",
    "apartment",
    "homepage",
    "local",
    "shelter"
  ],
  "hot-key": [
    "keyboard",
    "key",
    "command",
    "hot",
    "shortcut"
  ],
  "house": [
    "ui",
    "interface",
    "office",
    "building",
    "estate",
    "home",
    "house",
    "real",
    "page",
    "address",
    "apartment",
    "homepage",
    "local",
    "shelter"
  ],
  "i-add": [
    "ui",
    "interface",
    "expand",
    "increase",
    "new",
    "add",
    "create",
    "plus",
    "addition",
    "positive"
  ],
  "i-delete": [
    "ui",
    "interface",
    "close",
    "exit",
    "decrease",
    "delete",
    "remove",
    "minus",
    "cancel",
    "deletion",
    "less",
    "removal",
    "subtract"
  ],
  "i-remove": [
    "ui",
    "interface",
    "close",
    "exit",
    "cross",
    "delete",
    "remove",
    "cancel",
    "deletion",
    "removal",
    "denied",
    "discard",
    "dismiss",
    "wrong"
  ],
  "info": [
    "ui",
    "interface",
    "sign",
    "info",
    "travel",
    "alert",
    "information",
    "notification",
    "about",
    "faq",
    "help",
    "support",
    "tooltip"
  ],
  "journey": [
    "direction",
    "navigation",
    "location",
    "way",
    "path",
    "shape",
    "vector",
    "track",
    "route",
    "street",
    "road",
    "journey"
  ],
  "key": [
    "interface",
    "lock",
    "password",
    "security",
    "door",
    "key",
    "object",
    "protection",
    "secure",
    "access",
    "sell",
    "rent",
    "selling",
    "renting",
    "license",
    "open",
    "private",
    "passcode",
    "unlock"
  ],
  "keyboard-arrow-down": [
    "arrow",
    "bottom",
    "down",
    "descend",
    "downward"
  ],
  "keyboard-arrow-left": [
    "arrow",
    "back",
    "left",
    "previous",
    "direction",
    "backward",
    "backwards",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position"
  ],
  "keyboard-arrow-right": [
    "arrow",
    "forward",
    "right",
    "next",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "onward",
    "onwards"
  ],
  "keyboard-arrow-up": [
    "arrow",
    "top",
    "up",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "upward",
    "upwards"
  ],
  "l-check": [
    "notebook",
    "check",
    "computer",
    "laptop",
    "tech",
    "technology",
    "device",
    "mac",
    "monitor",
    "screen",
    "mark",
    "approved",
    "complete",
    "completed",
    "done",
    "checked",
    "pc",
    "personal"
  ],
  "l-circle": [
    "rotate",
    "loading",
    "progress",
    "wait",
    "interactive",
    "spinner",
    "rotation",
    "loader"
  ],
  "ladybug": [
    "animal",
    "bug",
    "error",
    "insect",
    "ladybird",
    "ladybug",
    "fly",
    "design",
    "development",
    "nature"
  ],
  "language": [
    "education",
    "translate",
    "language",
    "translation",
    "translator",
    "interpreter"
  ],
  "layers": [
    "logo",
    "layers",
    "order",
    "stack",
    "sheets",
    "floors",
    "files",
    "file",
    "network",
    "media",
    "structure",
    "business",
    "hierarchy",
    "layer",
    "map",
    "relations",
    "sitemap",
    "development",
    "filter",
    "management",
    "organization",
    "archive",
    "sheet",
    "layering",
    "stackable",
    "stacking"
  ],
  "leave": [
    "arrow",
    "out",
    "log",
    "sign",
    "close",
    "door",
    "exit",
    "leave",
    "logout",
    "outside"
  ],
  "letter": [
    "communication",
    "post",
    "send",
    "email",
    "mail",
    "message",
    "messages",
    "contact",
    "write",
    "envelope",
    "letter",
    "mailbox",
    "news",
    "newsletter"
  ],
  "letter-f": [
    "text",
    "letter",
    "alphabet"
  ],
  "letter-g": [
    "text",
    "letter",
    "alphabet"
  ],
  "letter-i": [
    "text",
    "letter",
    "alphabet"
  ],
  "letter-l": [
    "text",
    "letter",
    "alphabet"
  ],
  "letter-t": [
    "text",
    "letter",
    "alphabet"
  ],
  "letter-v": [
    "text",
    "letter",
    "alphabet"
  ],
  "letter-x": [
    "text",
    "letter",
    "alphabet"
  ],
  "level": [
    "stats",
    "chart",
    "graph",
    "report",
    "statistics",
    "analytics",
    "dashboard",
    "marketing",
    "metrics",
    "usability",
    "forecasting"
  ],
  "line-chart": [
    "curve",
    "line",
    "data",
    "stats",
    "trend",
    "chart",
    "graph",
    "statistics",
    "analytics",
    "currency",
    "price",
    "bitcoin",
    "performance",
    "cryptocurrency",
    "financial",
    "plot",
    "shares",
    "stocks"
  ],
  "line-chart-cube": [
    "chart",
    "graph",
    "healthcare",
    "health",
    "medical",
    "beat",
    "pulse"
  ],
  "link": [
    "url",
    "hyperlink",
    "chain",
    "link",
    "share",
    "connection",
    "ui",
    "interface",
    "connections",
    "text",
    "web",
    "editing",
    "linked",
    "links"
  ],
  "list": [
    "process",
    "organize",
    "schedule",
    "document",
    "list",
    "agenda",
    "shopping",
    "check",
    "checklist",
    "item",
    "items",
    "listing",
    "tasks",
    "todo",
    "inventory",
    "plan",
    "wishlist"
  ],
  "lock": [
    "security",
    "private",
    "protection",
    "padlock",
    "lock",
    "login",
    "password",
    "safe",
    "safety",
    "locked",
    "privacy",
    "protected",
    "secure",
    "closed",
    "encryption",
    "protect",
    "policy"
  ],
  "log-out": [
    "arrow",
    "out",
    "ui",
    "interface",
    "log",
    "sign",
    "close",
    "door",
    "exit",
    "leave",
    "logout",
    "outside"
  ],
  "loudspeaker": [
    "media",
    "multimedia",
    "audio",
    "alert",
    "notification",
    "speaker",
    "voice",
    "megaphone",
    "loudspeaker"
  ],
  "m-agile-resources": [
    "sport",
    "training",
    "exercise",
    "workout",
    "games",
    "olympic",
    "jogging",
    "marathon",
    "running",
    "olympics",
    "sprint",
    "runner"
  ],
  "m-ai-assistant-dashboard": [
    "light",
    "edit",
    "filter",
    "photo",
    "brightness",
    "effect",
    "stars",
    "artificial",
    "intelligence",
    "spark",
    "sparkle",
    "chatgpt"
  ],
  "m-alerts-and-notifications": [
    "sign",
    "error",
    "danger",
    "alert",
    "attention",
    "caution",
    "exclamation",
    "problem",
    "warning",
    "red"
  ],
  "m-assets-configurations": [
    "files",
    "file",
    "storage",
    "ui",
    "interface",
    "inbox",
    "folder",
    "organize",
    "box",
    "document",
    "furniture",
    "collection",
    "documents",
    "editor",
    "archive",
    "container",
    "drawer",
    "cabinet",
    "handle",
    "safebox",
    "email",
    "mail",
    "mailbox"
  ],
  "m-attendance": [
    "clock",
    "time",
    "watch",
    "alarm",
    "timer",
    "progress",
    "availability",
    "available",
    "daily",
    "day",
    "monthly",
    "schedule",
    "weekly",
    "yearly",
    "wait",
    "alert",
    "appointment",
    "countdown",
    "track",
    "event",
    "tracking",
    "deadline",
    "hour",
    "history"
  ],
  "m-budget-statement": [
    "budget",
    "cash",
    "payment",
    "coins",
    "money",
    "stack",
    "savings",
    "change",
    "business",
    "finance",
    "funding"
  ],
  "m-calendar": [
    "plan",
    "time",
    "schedule",
    "date",
    "reminder",
    "event",
    "appointment",
    "calendar",
    "ui",
    "interface",
    "day",
    "planning",
    "month",
    "timetable",
    "year"
  ],
  "m-crm": [
    "work",
    "business",
    "finance",
    "bag",
    "briefcase",
    "job",
    "office",
    "portfolio",
    "suitcase"
  ],
  "m-devops": [
    "ui",
    "interface",
    "control",
    "slider",
    "preferences",
    "system",
    "edit",
    "options",
    "settings",
    "filter",
    "adjust",
    "adjustment",
    "option",
    "configuration",
    "configure",
    "parameter",
    "parameters",
    "setting",
    "setup",
    "tools",
    "sliders"
  ],
  "m-diagrams": [
    "files",
    "file",
    "network",
    "work",
    "structure",
    "business",
    "hierarchy",
    "layer",
    "layers",
    "chart",
    "design",
    "map",
    "relations",
    "sitemap",
    "development",
    "filter",
    "management",
    "organization",
    "flow"
  ],
  "m-dms": [
    "file",
    "folder",
    "document",
    "text",
    "note",
    "report",
    "page",
    "paper",
    "item",
    "draft",
    "single",
    "letter",
    "content",
    "sheet"
  ],
  "m-documents": [
    "layers",
    "stack",
    "page",
    "copy",
    "clone",
    "duplicate",
    "content",
    "files",
    "file",
    "backup",
    "group",
    "document",
    "copies",
    "documents",
    "paste",
    "draft"
  ],
  "m-easy-help": [
    "ui",
    "interface",
    "sign",
    "info",
    "mark",
    "alert",
    "information",
    "notification",
    "about",
    "faq",
    "help",
    "support",
    "ask",
    "query",
    "question",
    "interrogation"
  ],
  "m-easy-plugins": [
    "files",
    "file",
    "storage",
    "ui",
    "interface",
    "inbox",
    "folder",
    "organize",
    "box",
    "document",
    "furniture",
    "collection",
    "documents",
    "editor",
    "archive",
    "container",
    "drawer",
    "cabinet",
    "handle",
    "safebox",
    "email",
    "mail",
    "mailbox"
  ],
  "m-gantt": [
    "time",
    "chart",
    "graph",
    "management",
    "timer",
    "project",
    "gantt",
    "timeline"
  ],
  "m-git-integration": [
    "arrow",
    "forward",
    "right",
    "combine",
    "join",
    "merge",
    "chevron",
    "caret",
    "direction",
    "expand",
    "control",
    "git",
    "version",
    "pointing",
    "together",
    "unify",
    "unite"
  ],
  "m-helpdesk": [
    "ui",
    "interface",
    "shopping",
    "safe",
    "object",
    "help",
    "support",
    "life",
    "lifebuoy",
    "lifering"
  ],
  "m-knowledge-base": [
    "business",
    "finance",
    "bulb",
    "idea",
    "lamp",
    "light"
  ],
  "m-milestones": [
    "navigation",
    "ui",
    "interface",
    "layout",
    "list",
    "menu",
    "options",
    "bullet",
    "bullets",
    "items",
    "lines",
    "text",
    "unordered"
  ],
  "m-mind-maps": [
    "files",
    "file",
    "network",
    "work",
    "structure",
    "business",
    "hierarchy",
    "layer",
    "layers",
    "chart",
    "design",
    "map",
    "relations",
    "sitemap",
    "development",
    "filter",
    "management",
    "organization",
    "flow"
  ],
  "m-payroll-and-invoicing-sheets": [
    "navigation",
    "ui",
    "interface",
    "layout",
    "list",
    "menu",
    "options",
    "bullet",
    "bullets",
    "items",
    "lines",
    "text",
    "unordered"
  ],
  "m-personal-finance": [
    "cash",
    "payment",
    "money",
    "wallet",
    "change",
    "shopping",
    "coin",
    "pay",
    "purse",
    "profit",
    "spend"
  ],
  "m-project-templates": [
    "files",
    "file",
    "network",
    "work",
    "structure",
    "business",
    "hierarchy",
    "layer",
    "layers",
    "chart",
    "design",
    "map",
    "relations",
    "sitemap",
    "development",
    "filter",
    "management",
    "organization",
    "flow"
  ],
  "m-resource-management": [
    "time",
    "chart",
    "graph",
    "management",
    "timer",
    "project",
    "gantt",
    "timeline"
  ],
  "m-risks": [
    "weather",
    "energy",
    "media",
    "light",
    "photo",
    "multimedia",
    "flash",
    "lightning",
    "activity",
    "cardio",
    "calories"
  ],
  "m-scrum-boards": [
    "sign",
    "info",
    "board",
    "display",
    "shopping",
    "advertise",
    "advertisement",
    "advertising",
    "billboard",
    "notice",
    "signboard",
    "list",
    "columns",
    "grid",
    "template",
    "moodboard",
    "pinboard",
    "collage"
  ],
  "m-sprint-dashboard": [
    "board",
    "list",
    "columns",
    "grid",
    "template",
    "moodboard",
    "pinboard",
    "collage"
  ],
  "m-task-templates": [
    "browser",
    "layout",
    "document",
    "paragraph",
    "text",
    "app",
    "tab",
    "list",
    "design",
    "internet",
    "web",
    "development",
    "page",
    "picture",
    "website",
    "image",
    "photo",
    "boxes",
    "grid",
    "masonry",
    "mockup",
    "site",
    "table",
    "tile",
    "view",
    "wireframe",
    "header",
    "sidebar",
    "webpage",
    "content",
    "description"
  ],
  "m-test-cases": [
    "select",
    "list",
    "answer",
    "check",
    "options",
    "filter",
    "todo",
    "completed",
    "checked",
    "tick",
    "question",
    "checkbox",
    "questionnaire",
    "survey"
  ],
  "m-time-reports": [
    "plan",
    "time",
    "schedule",
    "date",
    "reminder",
    "event",
    "appointment",
    "calendar",
    "ui",
    "interface",
    "day",
    "planning",
    "month",
    "timetable",
    "year"
  ],
  "m-timesheets": [
    "data",
    "columns",
    "grid",
    "table",
    "database",
    "sheet",
    "rows",
    "spreadsheet",
    "cells"
  ],
  "m-users": [
    "user",
    "profile",
    "account",
    "avatar",
    "person",
    "contact",
    "male",
    "man",
    "users",
    "member",
    "human",
    "friend",
    "follower"
  ],
  "mail": [
    "ui",
    "interface",
    "communication",
    "post",
    "send",
    "email",
    "mail",
    "message",
    "messages",
    "contact",
    "write",
    "envelope",
    "letter",
    "mailbox",
    "news",
    "newsletter"
  ],
  "manga-63": [
    "emoticon",
    "smiley",
    "cheerful",
    "happy",
    "smile",
    "comic",
    "manga"
  ],
  "mario-mushroom": [
    "play",
    "video",
    "game",
    "boost",
    "mushroom",
    "nintendo",
    "gaming",
    "arcade",
    "mario",
    "bros",
    "super",
    "bonus",
    "powerup"
  ],
  "medical-clipboard": [
    "cross",
    "document",
    "note",
    "notebook",
    "notes",
    "notepad",
    "clipboard",
    "healthcare",
    "medical",
    "medicine",
    "treatment",
    "hospital"
  ],
  "meeting": [
    "user",
    "group",
    "team",
    "meeting",
    "conversation",
    "dialog",
    "profile",
    "account",
    "avatar",
    "contact",
    "male",
    "man",
    "person",
    "users",
    "member",
    "appointment",
    "human",
    "friend",
    "follower",
    "community",
    "people"
  ],
  "menu": [
    "navigation",
    "ui",
    "interface",
    "lines",
    "list",
    "bars",
    "gallery",
    "hamburger",
    "menu",
    "options",
    "settings",
    "burger"
  ],
  "menu-6": [
    "navigation",
    "ui",
    "interface",
    "lines",
    "list",
    "bars",
    "gallery",
    "hamburger",
    "menu",
    "options",
    "settings",
    "burger"
  ],
  "menu-8": [
    "navigation",
    "ui",
    "interface",
    "lines",
    "list",
    "bars",
    "gallery",
    "hamburger",
    "menu",
    "options",
    "settings",
    "burger"
  ],
  "menu-more": [
    "navigation",
    "circle",
    "ui",
    "interface",
    "dot",
    "list",
    "gallery",
    "menu",
    "options",
    "settings",
    "circles",
    "dots",
    "more"
  ],
  "microsoft": [
    "logo",
    "microsoft",
    "line",
    "windows",
    "layout",
    "list",
    "design",
    "development",
    "shape",
    "gallery",
    "boxes",
    "column",
    "grid",
    "row",
    "table",
    "tile",
    "view",
    "square",
    "squares"
  ],
  "migrate": [
    "arrow",
    "line",
    "alternative",
    "arrows",
    "change",
    "direction",
    "exchange",
    "files",
    "flip",
    "horizontal",
    "swap",
    "switch",
    "transmit",
    "navigation",
    "directions",
    "gps",
    "location"
  ],
  "minus": [
    "ui",
    "interface",
    "close",
    "exit",
    "decrease",
    "delete",
    "remove",
    "minus",
    "cancel",
    "deletion",
    "less",
    "removal",
    "subtract"
  ],
  "molecule": [
    "science",
    "healthcare",
    "health",
    "medical",
    "atom",
    "chemistry",
    "molecule",
    "education",
    "school"
  ],
  "money-12": [
    "business",
    "finance",
    "cash",
    "payment",
    "money",
    "dollar",
    "banknotes"
  ],
  "money-time": [
    "change",
    "clock",
    "business",
    "time",
    "finance",
    "cash",
    "payment",
    "coins",
    "funding",
    "money"
  ],
  "moon": [
    "moon",
    "night",
    "weather"
  ],
  "move": [
    "arrow",
    "arrows",
    "direction",
    "move",
    "out",
    "directions",
    "enlarge",
    "expand",
    "fullscreen",
    "increase",
    "maximize",
    "reach",
    "window",
    "zoom",
    "tool"
  ],
  "move-left": [
    "arrow",
    "back",
    "left",
    "direction",
    "backward",
    "backwards",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "previous"
  ],
  "move-right": [
    "arrow",
    "forward",
    "right",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "next",
    "onward",
    "onwards"
  ],
  "move-up-2": [
    "arrow",
    "move",
    "top",
    "up",
    "upward",
    "organize",
    "arrange",
    "bring",
    "translate",
    "object",
    "rearrange",
    "reorganize",
    "push"
  ],
  "msgs": [
    "speech",
    "comment",
    "bubble",
    "conversation",
    "chatbox",
    "callout",
    "chats",
    "msgs",
    "messages"
  ],
  "n-check": [
    "ui",
    "interface",
    "success",
    "select",
    "check",
    "selected",
    "mark",
    "accept",
    "approve",
    "approved",
    "checkmark",
    "complete",
    "completed",
    "done",
    "checked",
    "tick",
    "checkbox",
    "ok"
  ],
  "networking": [
    "connection",
    "social",
    "ui",
    "interface",
    "communication",
    "network",
    "group",
    "team",
    "connect",
    "internet",
    "connected",
    "networking",
    "node",
    "nodes",
    "seo",
    "dots"
  ],
  "news": [
    "file",
    "communication",
    "post",
    "document",
    "note",
    "degree",
    "diploma",
    "report",
    "paper",
    "draft",
    "news",
    "parchment",
    "article",
    "blog"
  ],
  "nine": [
    "number",
    "nine"
  ],
  "note": [
    "file",
    "document",
    "text",
    "note",
    "page",
    "paper",
    "draft",
    "letter",
    "content",
    "post",
    "notebook",
    "notes",
    "notepad",
    "writing",
    "post it"
  ],
  "notepad": [
    "document",
    "education",
    "school",
    "note",
    "notebook",
    "notepad"
  ],
  "notes": [
    "business",
    "finance",
    "notebook",
    "notes",
    "notepad",
    "reminder",
    "to-do",
    "paste"
  ],
  "o-warning": [
    "sign",
    "point",
    "error",
    "danger",
    "alert",
    "attention",
    "caution",
    "exclamation",
    "notification",
    "warning",
    "octagon"
  ],
  "one": [
    "one",
    "number"
  ],
  "open-folder": [
    "files",
    "file",
    "folder",
    "document",
    "format",
    "office",
    "paper",
    "documents",
    "catalog",
    "envelope",
    "archive"
  ],
  "open-modal": [
    "arrow",
    "up",
    "file",
    "share",
    "storage",
    "transfer",
    "upload",
    "connection",
    "social",
    "export",
    "launch",
    "network",
    "outbox",
    "output",
    "sharing",
    "start"
  ],
  "open-window": [
    "arrow",
    "up",
    "file",
    "share",
    "storage",
    "transfer",
    "upload",
    "connection",
    "social",
    "export",
    "launch",
    "network",
    "outbox",
    "output",
    "sharing",
    "start"
  ],
  "options": [
    "ui",
    "interface",
    "control",
    "slider",
    "preferences",
    "system",
    "edit",
    "options",
    "settings",
    "filter",
    "filters",
    "adjust",
    "adjustment",
    "option",
    "configuration",
    "configure",
    "parameter",
    "parameters",
    "setting",
    "setup",
    "tools",
    "sliders"
  ],
  "p-add": [
    "communication",
    "new",
    "tech",
    "technology",
    "device",
    "mobile",
    "phone",
    "smartphone",
    "add",
    "plus",
    "telephone"
  ],
  "p-edit": [
    "change",
    "communication",
    "tech",
    "technology",
    "edit",
    "device",
    "mobile",
    "phone",
    "smartphone",
    "modify",
    "telephone"
  ],
  "palette": [
    "color",
    "colors",
    "painting",
    "palette",
    "pantone",
    "theme",
    "tones",
    "shades",
    "tool",
    "art",
    "design",
    "development",
    "paint",
    "draw",
    "brush",
    "painter",
    "artist",
    "swatches"
  ],
  "paragraph": [
    "ui",
    "interface",
    "layout",
    "document",
    "paragraph",
    "text",
    "list",
    "page",
    "picture",
    "image",
    "photo",
    "mockup",
    "wireframe",
    "content",
    "description",
    "typography"
  ],
  "pause": [
    "ui",
    "media",
    "control",
    "button",
    "multimedia",
    "pause"
  ],
  "pen": [
    "text",
    "message",
    "note",
    "pen",
    "edit",
    "pencil",
    "write",
    "draw",
    "create",
    "editing",
    "compose",
    "editor",
    "draft",
    "rename"
  ],
  "pencil": [
    "text",
    "message",
    "education",
    "school",
    "note",
    "design",
    "pen",
    "edit",
    "pencil",
    "write",
    "development",
    "draw",
    "create",
    "editing",
    "compose",
    "editor",
    "draft"
  ],
  "penguin": [
    "animal",
    "nature",
    "penguin",
    "emoticon",
    "smiley"
  ],
  "pennant": [
    "weather",
    "location",
    "message",
    "sport",
    "map",
    "tag",
    "important",
    "maps",
    "alert",
    "flag",
    "banner",
    "notify",
    "pennant"
  ],
  "phone": [
    "telephone",
    "phone",
    "call",
    "contact",
    "communication",
    "conversation",
    "talk",
    "mobile",
    "ringing",
    "calling"
  ],
  "pin": [
    "direction",
    "navigation",
    "position",
    "gps",
    "location",
    "map",
    "pin",
    "pushpin",
    "place",
    "marker",
    "maps",
    "locator",
    "address",
    "destination"
  ],
  "play": [
    "arrow",
    "forward",
    "right",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "next",
    "onward",
    "onwards",
    "play"
  ],
  "play-media": [
    "play",
    "media",
    "video",
    "film",
    "movie",
    "multimedia"
  ],
  "plus": [
    "ui",
    "interface",
    "expand",
    "increase",
    "new",
    "add",
    "create",
    "plus",
    "addition",
    "positive"
  ],
  "podium-trophy": [
    "sport",
    "blocks",
    "winner",
    "champion",
    "podium",
    "trophy",
    "victory"
  ],
  "pointing-left": [
    "arrow",
    "back",
    "left",
    "direction",
    "backward",
    "backwards",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "previous"
  ],
  "pointing-right": [
    "arrow",
    "forward",
    "right",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "next",
    "onward",
    "onwards"
  ],
  "poop": [
    "emoticon",
    "smiley",
    "happy",
    "excrement",
    "pet",
    "pile",
    "poo",
    "poop"
  ],
  "position-pin": [
    "direction",
    "navigation",
    "position",
    "gps",
    "location",
    "map",
    "pin",
    "place",
    "marker",
    "maps",
    "near",
    "nearby"
  ],
  "print": [
    "document",
    "scan",
    "paper",
    "device",
    "print",
    "printer",
    "fax",
    "office",
    "tech",
    "technology",
    "copy",
    "printing"
  ],
  "printer": [
    "document",
    "office",
    "tech",
    "technology",
    "device",
    "copy",
    "paper",
    "print",
    "fax",
    "printer",
    "printing"
  ],
  "priority": [
    "arrow",
    "move",
    "top",
    "up",
    "organize",
    "bring",
    "business",
    "hierarchy",
    "high",
    "layer",
    "layers",
    "list",
    "order",
    "priority",
    "seat"
  ],
  "profile": [
    "user",
    "profile",
    "account",
    "avatar",
    "contact",
    "woman",
    "man",
    "person",
    "users",
    "member",
    "human",
    "friend",
    "follower"
  ],
  "progress": [
    "loading",
    "progress",
    "success",
    "check",
    "wait",
    "approved",
    "checkmark",
    "tick",
    "loader"
  ],
  "puzzle-10": [
    "play",
    "extension",
    "game",
    "object",
    "puzzle",
    "solution"
  ],
  "puzzled": [
    "emoticon",
    "smiley",
    "concern",
    "confused",
    "puzzled",
    "thinking"
  ],
  "quite-happy": [
    "open",
    "emoticon",
    "smiley",
    "cheerful",
    "happy",
    "smile",
    "mouth",
    "laugh",
    "positive",
    "quite"
  ],
  "radiation": [
    "environment",
    "safety",
    "danger",
    "radiation",
    "toxic",
    "waste",
    "caution",
    "warning",
    "nuclear",
    "radioactive",
    "hazard",
    "energy",
    "virus",
    "atomic",
    "emergency",
    "sickness"
  ],
  "radio-btn": [
    "control",
    "button",
    "selection",
    "choice",
    "checked",
    "radio",
    "question",
    "questionnaire",
    "forms",
    "tickbox"
  ],
  "radio-btn-checked": [
    "control",
    "button",
    "selection",
    "choice",
    "checked",
    "radio",
    "question",
    "questionnaire",
    "forms",
    "tickbox"
  ],
  "receipt-list-42": [
    "shopping",
    "bill",
    "check",
    "sale",
    "invoice",
    "receipt",
    "expense",
    "income",
    "purchase"
  ],
  "recycling": [
    "arrows",
    "energy",
    "environment",
    "clean",
    "ecology",
    "green",
    "waste",
    "cycle",
    "garbage",
    "recycle",
    "recycling"
  ],
  "redo": [
    "arrow",
    "back",
    "curve",
    "forward",
    "invert",
    "redo",
    "repeat",
    "right",
    "rotate"
  ],
  "refresh-02": [
    "rotate",
    "loading",
    "progress",
    "tool",
    "wait",
    "spinner",
    "rotation",
    "loader"
  ],
  "reload": [
    "arrow",
    "repeat",
    "arrows",
    "exchange",
    "sync",
    "infinite",
    "infinity",
    "load",
    "loading",
    "loop",
    "process",
    "refresh",
    "reload",
    "replay",
    "update",
    "energy",
    "environment"
  ],
  "remove-like": [
    "save",
    "ui",
    "interface",
    "close",
    "delete",
    "remove",
    "award",
    "bookmark",
    "favorite",
    "favourite",
    "minus",
    "love",
    "like",
    "vote",
    "cancel",
    "star",
    "rate",
    "negative"
  ],
  "repeat": [
    "arrow",
    "repeat",
    "arrows",
    "circle",
    "round",
    "sync",
    "infinite",
    "infinity",
    "load",
    "loading",
    "loop",
    "process",
    "refresh",
    "reload",
    "replay",
    "update",
    "shuffle"
  ],
  "repeat-cycle": [
    "arrow",
    "repeat",
    "arrows",
    "circle",
    "round",
    "sync",
    "infinite",
    "infinity",
    "load",
    "loading",
    "loop",
    "process",
    "refresh",
    "reload",
    "replay",
    "update",
    "shuffle"
  ],
  "resize-x": [
    "arrow",
    "left",
    "right",
    "horizontal",
    "expand",
    "maximize",
    "resize",
    "stretch",
    "arrows",
    "enlarge",
    "fullscreen",
    "increase",
    "window",
    "zoom",
    "fit",
    "full",
    "measure",
    "responsive",
    "scale",
    "size",
    "width"
  ],
  "resize-y": [
    "arrow",
    "down",
    "up",
    "expand",
    "maximize",
    "vertical",
    "resize",
    "stretch",
    "arrows",
    "enlarge",
    "fullscreen",
    "increase",
    "window",
    "zoom",
    "fit",
    "full",
    "measure",
    "responsive",
    "scale",
    "size",
    "height"
  ],
  "robot": [
    "man",
    "kid",
    "robot",
    "emoticon",
    "smiley",
    "automation",
    "mechanical",
    "toy"
  ],
  "round-euro": [
    "business",
    "finance",
    "shopping",
    "money",
    "currency",
    "euro",
    "cashier"
  ],
  "router": [
    "connection",
    "network",
    "internet",
    "device",
    "signal",
    "router",
    "modem",
    "wireless",
    "radio",
    "wifi",
    "broadband"
  ],
  "s-add": [
    "ui",
    "interface",
    "expand",
    "increase",
    "new",
    "add",
    "create",
    "plus",
    "addition",
    "positive"
  ],
  "s-delete": [
    "ui",
    "interface",
    "close",
    "exit",
    "decrease",
    "delete",
    "remove",
    "minus",
    "cancel",
    "deletion",
    "less",
    "removal",
    "subtract"
  ],
  "s-edit": [
    "ui",
    "interface",
    "text",
    "message",
    "note",
    "pen",
    "edit",
    "pencil",
    "write",
    "draw",
    "create",
    "editing",
    "compose",
    "editor",
    "draft"
  ],
  "s-info": [
    "ui",
    "interface",
    "sign",
    "info",
    "alert",
    "information",
    "notification",
    "about",
    "faq",
    "help",
    "support",
    "tooltip"
  ],
  "s-plus": [
    "ui",
    "interface",
    "expand",
    "increase",
    "new",
    "add",
    "create",
    "plus",
    "addition",
    "positive"
  ],
  "s-question": [
    "ui",
    "interface",
    "sign",
    "info",
    "mark",
    "alert",
    "information",
    "notification",
    "about",
    "faq",
    "help",
    "support",
    "ask",
    "query",
    "question"
  ],
  "s-remove": [
    "ui",
    "interface",
    "close",
    "exit",
    "cross",
    "delete",
    "remove",
    "cancel",
    "deletion",
    "removal",
    "denied",
    "discard",
    "dismiss",
    "wrong"
  ],
  "s-warning": [
    "ui",
    "interface",
    "sign",
    "info",
    "stop",
    "mark",
    "error",
    "danger",
    "alert",
    "attention",
    "caution",
    "exclamation",
    "information",
    "notification",
    "warning"
  ],
  "sad": [
    "emoticon",
    "smiley",
    "unhappy",
    "sad",
    "disappointed"
  ],
  "satisfied": [
    "emoticon",
    "smiley",
    "cheerful",
    "happy",
    "smile",
    "positive",
    "satisfied"
  ],
  "scissors": [
    "edit",
    "tool",
    "cut",
    "scissors",
    "trim",
    "craft",
    "cutting",
    "shears",
    "trimming"
  ],
  "search": [
    "ui",
    "interface",
    "zoom",
    "glass",
    "view",
    "search",
    "find",
    "lens",
    "magnify",
    "explore",
    "lookup",
    "magnifier",
    "magnifying"
  ],
  "search-content": [
    "document",
    "paragraph",
    "text",
    "glass",
    "search",
    "content",
    "find",
    "lens",
    "magnifier",
    "zoom",
    "filter",
    "view",
    "research",
    "magnify",
    "magnifying",
    "seo",
    "article"
  ],
  "security": [
    "data",
    "ui",
    "interface",
    "security",
    "safety",
    "privacy",
    "protection",
    "secure",
    "access",
    "antivirus",
    "firewall",
    "shield",
    "protect",
    "insurance",
    "policy"
  ],
  "send": [
    "ui",
    "interface",
    "communication",
    "send",
    "email",
    "mail",
    "message",
    "messages",
    "contact",
    "write",
    "paper",
    "letter",
    "news",
    "fly",
    "airplane",
    "flight",
    "plane",
    "sending"
  ],
  "send-to-phone": [
    "data",
    "download",
    "save",
    "transfer",
    "import",
    "entry",
    "login",
    "send",
    "mobile",
    "phone",
    "smartphone",
    "receive"
  ],
  "server-rack": [
    "cloud",
    "data",
    "storage",
    "sync",
    "backup",
    "ftp",
    "hosting",
    "server",
    "rack"
  ],
  "settings": [
    "ui",
    "interface",
    "control",
    "slider",
    "preferences",
    "system",
    "edit",
    "options",
    "settings",
    "filter",
    "adjust",
    "adjustment",
    "option",
    "configuration",
    "configure",
    "parameter",
    "parameters",
    "setting",
    "setup",
    "tools",
    "sliders"
  ],
  "setup-preferences": [
    "ui",
    "interface",
    "control",
    "slider",
    "preferences",
    "system",
    "edit",
    "options",
    "settings",
    "filter",
    "adjust",
    "adjustment",
    "option",
    "configuration",
    "configure",
    "parameter",
    "parameters",
    "setting",
    "setup",
    "tools",
    "sliders"
  ],
  "seven": [
    "number",
    "seven"
  ],
  "shape-oval": [
    "circle",
    "design",
    "shape",
    "oval",
    "shapes"
  ],
  "share": [
    "arrow",
    "file",
    "share",
    "storage",
    "transfer",
    "upload",
    "connection",
    "social",
    "export",
    "output",
    "post",
    "sharing",
    "group",
    "connect",
    "connected",
    "networking",
    "node",
    "seo"
  ],
  "sickle": [
    "holidays",
    "halloween",
    "horror",
    "scary",
    "danger",
    "death",
    "sickle",
    "weapon"
  ],
  "six": [
    "number",
    "six"
  ],
  "skull": [
    "holidays",
    "object",
    "emoticon",
    "smiley",
    "danger",
    "dead",
    "death",
    "head",
    "poison",
    "skeleton",
    "skull",
    "bone",
    "emoji"
  ],
  "slide-left": [
    "arrow",
    "left",
    "arrows",
    "move",
    "navigation",
    "ui",
    "interface",
    "lines",
    "open",
    "list",
    "bars",
    "menu",
    "options",
    "settings",
    "slide"
  ],
  "slide-right": [
    "arrow",
    "right",
    "arrows",
    "move",
    "navigation",
    "ui",
    "interface",
    "lines",
    "open",
    "list",
    "bars",
    "menu",
    "options",
    "settings",
    "slide"
  ],
  "smile": [
    "emoticon",
    "smiley",
    "cheerful",
    "happy",
    "smile",
    "positive",
    "satisfied"
  ],
  "snow": [
    "weather",
    "holidays",
    "snow",
    "flake"
  ],
  "sort": [
    "ui",
    "interface",
    "tool",
    "settings",
    "filter",
    "categories",
    "category",
    "filtering",
    "filters",
    "refine",
    "search",
    "sort",
    "funnel",
    "seo"
  ],
  "sort-tool": [
    "ui",
    "interface",
    "tool",
    "settings",
    "filter",
    "categories",
    "category",
    "filtering",
    "filters",
    "refine",
    "search",
    "sort",
    "funnel",
    "seo"
  ],
  "sorting": [
    "sort",
    "interactive",
    "sorting"
  ],
  "speechless": [
    "no",
    "emoticon",
    "smiley",
    "lips",
    "sealed",
    "speechless",
    "words"
  ],
  "split-branch": [
    "arrow",
    "arrows",
    "change",
    "direction",
    "move",
    "navigation",
    "circle",
    "expand",
    "divide",
    "separate",
    "split",
    "branch",
    "controller",
    "git",
    "version"
  ],
  "star": [
    "star",
    "bookmark",
    "favorite",
    "favourite",
    "award",
    "rating",
    "rate",
    "like",
    "review",
    "ranking",
    "symbol",
    "save",
    "ui",
    "interface",
    "holidays",
    "love",
    "vote",
    "scoring"
  ],
  "strikethrough": [
    "font",
    "text",
    "type",
    "typography",
    "style",
    "editing",
    "formatting",
    "strikethrough"
  ],
  "subscript": [
    "font",
    "format",
    "text",
    "typography",
    "letter",
    "subscript",
    "type",
    "style",
    "editing",
    "formatting"
  ],
  "success": [
    "ui",
    "interface",
    "success",
    "select",
    "check",
    "selected",
    "mark",
    "accept",
    "approve",
    "approved",
    "checkmark",
    "complete",
    "completed",
    "done",
    "checked",
    "tick",
    "checkbox",
    "ok"
  ],
  "superscript": [
    "font",
    "format",
    "text",
    "typography",
    "square",
    "letter",
    "superscript",
    "type",
    "style",
    "editing",
    "formatting"
  ],
  "sync-devices": [
    "data",
    "sync",
    "transfer",
    "connection",
    "update",
    "connect",
    "tech",
    "technology",
    "device",
    "mobile",
    "phone",
    "smartphone",
    "synchronization",
    "synchronize",
    "syncing"
  ],
  "tag": [
    "badge",
    "sale",
    "label",
    "price",
    "mark",
    "shop",
    "bookmark",
    "tag",
    "interface",
    "organize",
    "shopping",
    "discount",
    "ecommerce",
    "category",
    "store",
    "attribute"
  ],
  "tag-add": [
    "organize",
    "new",
    "shopping",
    "price",
    "discount",
    "ecommerce",
    "sale",
    "add",
    "plus",
    "category",
    "label",
    "tag",
    "store",
    "attribute"
  ],
  "tag-remove": [
    "delete",
    "remove",
    "organize",
    "shopping",
    "price",
    "discount",
    "ecommerce",
    "sale",
    "category",
    "label",
    "tag",
    "cancel",
    "store",
    "attribute"
  ],
  "target": [
    "arrow",
    "target",
    "center",
    "goal",
    "archery",
    "ui",
    "interface",
    "business",
    "finance",
    "dartboard",
    "darts",
    "goals",
    "targeting",
    "eye",
    "aim",
    "marketing",
    "objective",
    "bull's",
    "bullseye",
    "motive",
    "purpose"
  ],
  "text": [
    "font",
    "text",
    "typography",
    "letter",
    "type",
    "edit",
    "color",
    "style",
    "formatting",
    "colour"
  ],
  "text-align-justify": [
    "line",
    "align",
    "alignment",
    "paragraph",
    "text",
    "typography",
    "justify",
    "font",
    "type",
    "editing"
  ],
  "theater": [
    "play",
    "school",
    "movie",
    "artist",
    "mask",
    "performance",
    "cinema",
    "theater",
    "theatre",
    "drama",
    "acting",
    "actor",
    "tragedy",
    "film",
    "screen",
    "show",
    "live",
    "stage",
    "audience",
    "curtains"
  ],
  "three": [
    "three",
    "number"
  ],
  "thumb-down": [
    "down",
    "no",
    "finger",
    "gesture",
    "favorite",
    "emoticon",
    "smiley",
    "like",
    "thumbs",
    "vote",
    "dislike",
    "unlike"
  ],
  "thumb-up": [
    "up",
    "hand",
    "finger",
    "gesture",
    "favorite",
    "favourite",
    "approve",
    "like",
    "thumbs",
    "vote",
    "rate",
    "thumb"
  ],
  "time-clock": [
    "clock",
    "time",
    "watch",
    "alarm",
    "timer",
    "progress",
    "availability",
    "available",
    "daily",
    "day",
    "monthly",
    "schedule",
    "weekly",
    "yearly",
    "wait",
    "alert",
    "appointment",
    "countdown",
    "track",
    "event",
    "tracking",
    "deadline",
    "hour",
    "history"
  ],
  "timeline": [
    "data",
    "schedule",
    "time",
    "chart",
    "timer",
    "events",
    "event",
    "plan",
    "history",
    "timeline",
    "past"
  ],
  "timer": [
    "time",
    "cooking",
    "kitchen",
    "timer",
    "stopwatch"
  ],
  "todo": [
    "file",
    "form",
    "document",
    "list",
    "note",
    "notebook",
    "notes",
    "pad",
    "design",
    "report",
    "check",
    "notepad",
    "development",
    "page",
    "paper",
    "paste",
    "mark",
    "checklist",
    "tasks",
    "todo",
    "clipboard",
    "checkmark",
    "complete",
    "completed",
    "done",
    "marks",
    "task"
  ],
  "tool-hand": [
    "move",
    "drag",
    "tool",
    "hand",
    "pan",
    "privacy"
  ],
  "tracker": [
    "location",
    "dartboard",
    "goal",
    "target",
    "map",
    "focus",
    "maps",
    "aim",
    "crosshair",
    "radar"
  ],
  "transaction": [
    "arrows",
    "exchange",
    "finance",
    "payment",
    "money",
    "coin",
    "agreement",
    "transaction",
    "buyer",
    "seller"
  ],
  "trash": [
    "remove",
    "delete",
    "can",
    "bin",
    "trash",
    "waste",
    "garbage",
    "recycle",
    "junk",
    "furniture",
    "recycling",
    "dump",
    "dustbin",
    "rubbish",
    "trashcan"
  ],
  "tree": [
    "plant",
    "nature",
    "tree",
    "christmas",
    "forest",
    "garden",
    "park",
    "pine",
    "holidays",
    "decoration"
  ],
  "tree-ball": [
    "holidays",
    "ball",
    "decoration",
    "tree",
    "christmas"
  ],
  "trend-down": [
    "arrow",
    "line",
    "down",
    "progress",
    "decrease",
    "diagram",
    "sales",
    "shrink",
    "stats",
    "trend",
    "visits"
  ],
  "trend-up": [
    "arrow",
    "line",
    "direction",
    "keyboard",
    "move",
    "navigation",
    "out",
    "position",
    "top",
    "up",
    "upward",
    "upwards",
    "increase",
    "progress",
    "diagram",
    "sales",
    "stats",
    "trend",
    "visits",
    "growth"
  ],
  "triangle": [
    "arrow",
    "bottom",
    "descend",
    "down",
    "downward"
  ],
  "trophy": [
    "sport",
    "achievement",
    "award",
    "medal",
    "prize",
    "winner",
    "cup",
    "champion",
    "trophy",
    "victory"
  ],
  "turn-off": [
    "ui",
    "media",
    "power",
    "button",
    "multimedia",
    "off",
    "on"
  ],
  "two": [
    "two",
    "number"
  ],
  "type-tool": [
    "input",
    "cursor",
    "tool",
    "paragraph",
    "text",
    "type",
    "typography",
    "edit",
    "write",
    "mouse",
    "point",
    "pointer",
    "editing",
    "insert",
    "typing",
    "writing",
    "area",
    "character",
    "textarea"
  ],
  "underline": [
    "font",
    "text",
    "type",
    "typography",
    "style",
    "editing",
    "underline",
    "formatting"
  ],
  "undo": [
    "arrow",
    "back",
    "left",
    "undo",
    "previous",
    "revert",
    "curve",
    "invert",
    "redo",
    "repeat",
    "rotate",
    "backward",
    "refund"
  ],
  "unlink": [
    "share",
    "connection",
    "ui",
    "interface",
    "connections",
    "remove",
    "text",
    "web",
    "editing",
    "break",
    "chain",
    "hyperlink",
    "link",
    "linked",
    "links",
    "url",
    "broken",
    "unlink"
  ],
  "unlocked": [
    "ui",
    "interface",
    "lock",
    "login",
    "password",
    "security",
    "safe",
    "safety",
    "locked",
    "padlock",
    "privacy",
    "protected",
    "protection",
    "secure",
    "closed",
    "encryption",
    "protect",
    "theft",
    "unlock",
    "unlocked",
    "unsafe",
    "unsecure"
  ],
  "update": [
    "arrow",
    "repeat",
    "arrows",
    "exchange",
    "sync",
    "infinite",
    "infinity",
    "load",
    "loading",
    "loop",
    "process",
    "refresh",
    "reload",
    "replay",
    "update",
    "energy",
    "environment"
  ],
  "upload": [
    "arrow",
    "direction",
    "top",
    "up",
    "upward",
    "file",
    "share",
    "storage",
    "transfer",
    "upload",
    "connection",
    "social",
    "ui",
    "interface",
    "update",
    "communication",
    "export",
    "launch",
    "network",
    "outbox",
    "output",
    "post",
    "sharing",
    "start",
    "send"
  ],
  "user": [
    "user",
    "profile",
    "account",
    "avatar",
    "person",
    "contact",
    "male",
    "man",
    "users",
    "member",
    "human",
    "friend",
    "follower"
  ],
  "user-add": [
    "user",
    "new",
    "profile",
    "account",
    "avatar",
    "contact",
    "male",
    "man",
    "person",
    "add",
    "create",
    "plus",
    "users",
    "friend",
    "follower"
  ],
  "user-create": [
    "user",
    "new",
    "profile",
    "account",
    "avatar",
    "contact",
    "male",
    "man",
    "person",
    "add",
    "create",
    "plus",
    "users",
    "friend",
    "follower"
  ],
  "user-delete": [
    "user",
    "delete",
    "remove",
    "profile",
    "account",
    "avatar",
    "contact",
    "male",
    "man",
    "person",
    "minus",
    "cancel",
    "users",
    "friend",
    "follower"
  ],
  "user-group": [
    "user",
    "group",
    "team",
    "profile",
    "account",
    "avatar",
    "contact",
    "man",
    "person",
    "users",
    "member",
    "human",
    "friend",
    "community",
    "people",
    "collaboration",
    "collective"
  ],
  "users": [
    "person",
    "user",
    "users",
    "people",
    "team",
    "group",
    "profile",
    "account",
    "avatar",
    "contact",
    "man",
    "member",
    "human",
    "friend",
    "community",
    "collaboration",
    "collective",
    "players",
    "lineup"
  ],
  "users-meeting": [
    "user",
    "communication",
    "group",
    "team",
    "meeting",
    "answer",
    "chat",
    "comment",
    "comments",
    "conversation",
    "dialog",
    "forum",
    "message",
    "messages",
    "reply",
    "speaking",
    "talk",
    "profile",
    "account",
    "avatar",
    "contact",
    "male",
    "man",
    "person",
    "service",
    "help",
    "support",
    "users",
    "member",
    "appointment",
    "human",
    "friend",
    "customer",
    "follower",
    "community",
    "people"
  ],
  "users-mm": [
    "network",
    "group",
    "team",
    "man",
    "men",
    "organization",
    "users",
    "community",
    "people",
    "family",
    "collective",
    "friends",
    "players",
    "lineup",
    "coworking",
    "population"
  ],
  "users-wm": [
    "network",
    "group",
    "team",
    "organization",
    "users",
    "community",
    "people",
    "family",
    "collective",
    "friends",
    "players",
    "lineup",
    "coworking",
    "population"
  ],
  "video": [
    "camera",
    "video",
    "record",
    "movie",
    "film",
    "meeting",
    "play",
    "media",
    "editing",
    "multimedia",
    "show"
  ],
  "video-gallery-2": [
    "media",
    "playlist",
    "video",
    "player",
    "film",
    "movie",
    "gallery",
    "photography",
    "album",
    "camera",
    "youtube",
    "episodes"
  ],
  "video-playlist": [
    "play",
    "media",
    "playlist",
    "video",
    "library",
    "film",
    "movie",
    "collection",
    "gallery",
    "photos",
    "album",
    "watchlist",
    "player",
    "entertainment",
    "bookmarks",
    "tv show",
    "episode",
    "episodes"
  ],
  "volume-2": [
    "music",
    "control",
    "volume",
    "audio",
    "sound",
    "speaker",
    "media",
    "multimedia",
    "mute"
  ],
  "volume-down": [
    "down",
    "media",
    "volume",
    "multimedia",
    "audio",
    "sound",
    "speaker"
  ],
  "warning": [
    "sign",
    "error",
    "danger",
    "alert",
    "attention",
    "caution",
    "exclamation",
    "problem",
    "warning",
    "red"
  ],
  "warning-sign": [
    "sign",
    "error",
    "danger",
    "alert",
    "attention",
    "caution",
    "exclamation",
    "problem",
    "warning",
    "red"
  ],
  "window-add": [
    "ui",
    "interface",
    "window",
    "application",
    "browser",
    "windows",
    "app",
    "new",
    "internet",
    "web",
    "page",
    "add",
    "create",
    "plus",
    "frame",
    "webpage",
    "addition",
    "widget",
    "software",
    "online",
    "dock",
    "plugin"
  ],
  "window-maximize": [
    "arrow",
    "right",
    "move",
    "out",
    "top",
    "interface",
    "enlarge",
    "expand",
    "fullscreen",
    "increase",
    "maximize",
    "reach",
    "window",
    "zoom",
    "application",
    "browser",
    "windows"
  ],
  "wink-11": [
    "emoticon",
    "smiley",
    "cheerful",
    "happy",
    "smile",
    "positive",
    "satisfied",
    "wink"
  ],
  "wireframe": [
    "browser",
    "layout",
    "app",
    "tab",
    "design",
    "internet",
    "web",
    "development",
    "website",
    "mockup",
    "site",
    "wireframe",
    "webpage"
  ],
  "zipped-file": [
    "file",
    "folder",
    "document",
    "extension",
    "archive",
    "zip",
    "compressed",
    "zipped"
  ],
  "zoom-in": [
    "ui",
    "interface",
    "enlarge",
    "increase",
    "zoom",
    "in",
    "glass",
    "plus",
    "view",
    "search",
    "find",
    "lens",
    "magnify",
    "explore",
    "lookup",
    "magnifier",
    "magnifying",
    "approach",
    "hand",
    "gesture",
    "touch",
    "gestures",
    "stretch"
  ],
  "zoom-minus": [
    "out",
    "ui",
    "interface",
    "zoom",
    "glass",
    "view",
    "search",
    "minus",
    "find",
    "lens",
    "magnify",
    "explore",
    "lookup",
    "magnifier",
    "magnifying",
    "recede",
    "reduce"
  ],
  "zoom-out": [
    "out",
    "ui",
    "interface",
    "zoom",
    "glass",
    "view",
    "search",
    "minus",
    "find",
    "lens",
    "magnify",
    "explore",
    "lookup",
    "magnifier",
    "magnifying",
    "recede",
    "reduce"
  ],
  "zoom-plus": [
    "ui",
    "interface",
    "enlarge",
    "increase",
    "zoom",
    "in",
    "glass",
    "plus",
    "view",
    "search",
    "find",
    "lens",
    "magnify",
    "explore",
    "lookup",
    "magnifier",
    "magnifying",
    "approach"
  ]
}
